import { useMemo } from "react";
import { useSuperAdminSingleSuborg } from "../../../context/SuperAdmin/SingleSuborgContext";
import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { RowUserSuborg } from "./RowUserSuborg";

const SingleSuborgTable = () => {
  const {
    suborgUsers,
    setSelectedSuborgUsers,
    selectedSuborgUsers,
    searchQuery,
  } = useSuperAdminSingleSuborg();

  // Filtro de usuarios por búsqueda
  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchQuery.toLowerCase().trim();
    return suborgUsers.filter(
      (u) =>
        `${u.nombres} ${u.apellidos}`
          .toLowerCase()
          .includes(normalizedSearch) ||
        u.email.toLowerCase().includes(normalizedSearch)
    );
  }, [suborgUsers, searchQuery]);

  // Manejar selección/deselección de un permiso
  const handleSelect = (id: string) => {
    setSelectedSuborgUsers((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    setSelectedSuborgUsers(filteredUsers.map((user) => user.id_usuario));
  };

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedSuborgUsers.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedSuborgUsers([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Apellido
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Email
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Estado
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredUsers.length > 0 ? (
            filteredUsers.map((usuario, index) => (
              <RowUserSuborg
                usuario={usuario}
                i={index + 1}
                key={usuario.id_usuario}
                handleSelect={handleSelect}
                isSelected={selectedSuborgUsers.includes(usuario.id_usuario)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleSuborgTable;
